import './App.css';
import MyRouter from './router/router';

function App() {
  return (
    <div className="App">
      <MyRouter />
    </div>
  );
}

export default App;
